module.exports = __webpack_public_path__ + "img/right_icon_1.c48764b.png";